export function cardsCarousel() {
    $('.cards-carousel-wrap').each(function () {
        const cardsWrapper = $(this);

        cardsWrapper.find('.cards-carousel').each(function () {
            const cardsCarousel = $(this);

            $(window).on('scroll load resize', function () {
                let scrollTop = $(window).scrollTop();
                let windowWidth = $(window).width();
                const cardsWrapperOffsetTop = cardsWrapper.offset().top;
                const cardsWrapperHeight = cardsWrapper.innerHeight();
                if (scrollTop + windowWidth > cardsWrapperOffsetTop && scrollTop < cardsWrapperOffsetTop + cardsWrapperHeight) {
                    let indent = (((scrollTop + windowWidth) - cardsWrapperOffsetTop) / windowWidth * 100) * 0.3;
                    cardsCarousel.css('transform', 'translateX(-' + indent + '%)')
                    if (cardsCarousel.hasClass('reverse')) {
                        cardsCarousel.css('transform', 'translateX(' + indent + '%)')
                    }
                }
            })
        })
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/cardsCarousel.js